import React from "react";
import PropTypes from "prop-types";
import RModal from "react-modal";
import styled, { keyframes } from "styled-components";
import chroma from "chroma-js";

import { colors } from "../../theme";

const appear = keyframes`
  from {
    transform: translateY(-80px);
  }
`;

const Container = styled.div`
  animation: ${appear} 0.6s;
  background: white;
  margin: auto;
  max-height: 100vh;
  pointer-events: auto;
  width: 500px;
  overflow: auto;
  position: relative;
  z-index: 1;

  @media (max-width: 499px) {
    width: 100%;
  }

  h1 {
    background: ${(props) =>
      props.titleBackgroundColor
        ? props.titleBackgroundColor
        : colors.menuTitleColor};
    color: white;
    font-size: 2.8rem;
    font-weight: 500;
    line-height: 3.4rem;
    padding: 27px 20px;
    text-transform: uppercase;
    text-align: center;
    text-indent: 52px;

    @media (max-width: 767px) {
      padding: 13px 20px;
      text-align: left;
      text-indent: 0;
    }
  }

  .OverlayLoaderStickyWrapper {
    bottom: 0;
    position: relative;
    top: 0;
  }
`;

const Close = styled.button`
  background: white;
  border-radius: 50%;
  color: ${colors.menuTitleColor};
  float: right;
  font-size: 2.3rem;
  height: 30px;
  margin: 29px 20px 0;
  transition: 0.3s;
  width: 30px;

  @media (max-width: 767px) {
    margin: 15px 20px 0;
  }

  :hover {
    background: ${(props) =>
      chroma(
        props.hoverBackgroundColor
          ? props.hoverBackgroundColor
          : colors.menuTitleColor
      ).brighten(1.25)};
    color: white;
  }
`;

function Modal({
  isOpen,
  handleOpen,
  handleClose,
  hideButton,
  closeHoverBackgroundColor,
  buttonText,
  title,
  titleBackgroundColor,
  contentLabel,
  children,
}) {
  return (
    <>
      {!hideButton && <button onClick={handleOpen}>{buttonText}</button>}
      <RModal
        isOpen={isOpen}
        onRequestClose={handleClose}
        contentLabel={contentLabel}
        style={{
          content: {
            background: "transparent",
            border: 0,
            borderRadius: 0,
            bottom: 0,
            left: 0,
            padding: 0,
            pointerEvents: "none",
            right: 0,
            top: 0,
          },
        }}
      >
        <Container titleBackgroundColor={titleBackgroundColor}>
          <Close
            hoverBackgroundColor={closeHoverBackgroundColor}
            title="Annuler"
            onClick={handleClose}
          >
            <i className="far fa-times" />
          </Close>
          <h1>{title}</h1>
          <div>{children}</div>
        </Container>
      </RModal>
    </>
  );
}

Modal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  handleOpen: PropTypes.func,
  handleClose: PropTypes.func.isRequired,
  closeHoverBackgroundColor: PropTypes.string,
  hideButton: PropTypes.bool,
  buttonText: PropTypes.string,
  title: PropTypes.string.isRequired,
  titleBackgroundColor: PropTypes.string,
  contentLabel: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

export default Modal;
